<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${cafeteria.name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="cafeteria" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "cafeteria-view-logs",

  components: { LogListTable },

  props: ["cafeteria"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
